import React from 'react'
import { Row, Col, Image, Button } from 'react-bootstrap'
//import ScriptTag from 'react-script-tag'

const url =
  'https://www.myautoloan.com/partner/carfinder.html?utm_distil=carfinder&source=carfinder&site=mal&type=type_notset&term=term_notset'

// <a rel="nofollow" href="javascript:validateAndSubmit('LoanButton')" title="Apply for a loan">
const Financing = props => (
  <Row componentClass="article">
    <Col mdOffset={2} md={8} xs={12}>
      <h1>Auto Financing and Refinancing</h1>
      <Image
        responsive
        alt="myautoloan.com"
        style={{ width: '300px', marginTop: '-5px' }}
        src="https://carfinder.com/assets/img/MAL-logo-HDF-300dpi.png"
        title=""
      />
      <form name="GetALoanForm" id="GetALoanForm" method="post">
        <Button rel="nofollow" href={url} title="Apply for a loan">
          <Image
            responsive
            alt="One application. Up to 4 loan offers in minutes."
            src="https://carfinder.com/assets/img/MAL.jpg"
            title=""
          />
        </Button>
      </form>
          
    </Col>
  </Row>
  
)

export default Financing



// WEBPACK FOOTER //
// ./src/components/Financing.js